import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Servis listelerinde rota metriğini (mesafe / süre) gösteren hücre.
 * - Hesaplanmışsa (totalDistance > 0 ve totalDuration > 0): "24.6 km · 54 dk" şeklinde sade gösterir.
 * - Eksikse: estetik kırmızı bir rozet ("Hesaplanmadı") + açıklama (title) gösterir.
 *
 * Salt görüntüleme; hiçbir veri değiştirmez. DataGrid renderCell içinde kullanılır.
 */
const ServiceMetricCell = ({ row }) => {
  const { t } = useTranslation();

  const duration = Number(row?.totalDuration);
  const distance = Number(row?.totalDistance);
  const hasDuration = Number.isFinite(duration) && duration > 0;
  const hasDistance = Number.isFinite(distance) && distance > 0;
  const isComputed = hasDuration && hasDistance;

  if (isComputed) {
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          color: "#33475b",
          fontSize: "13px",
          lineHeight: 1.6,
        }}
      >
        <span style={{ fontWeight: 600 }}>{distance.toFixed(1)} km</span>
        <span style={{ opacity: 0.45 }}>·</span>
        <span style={{ fontWeight: 600 }}>
          {Math.round(duration)} {t("minutes")}
        </span>
      </span>
    );
  }

  return (
    <span
      title={t("metricsNotComputedHint")}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: "#fdecea",
        color: "#c0392b",
        border: "1px solid #f5c6c0",
        borderRadius: "999px",
        padding: "2px 10px",
        fontSize: "12px",
        fontWeight: 600,
        lineHeight: 1.7,
        whiteSpace: "nowrap",
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: "7px",
          height: "7px",
          borderRadius: "50%",
          background: "#e74c3c",
          display: "inline-block",
          flexShrink: 0,
        }}
      />
      {t("metricsNotComputed")}
    </span>
  );
};

export default ServiceMetricCell;
